import { render } from "./ServicesPage.vue?vue&type=template&id=63f133fe"
const script = {}

import "./ServicesPage.vue?vue&type=style&index=0&id=63f133fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__